<template>
  <div class="container">
    <div class="text-center title-tc font-weight-bold mt-5">GOGO CINEMA INSTRUCTIONS / TERMS & CONDITIONS</div>

    <p class="mb-0 py-5">
      Each Ticket purchased is a license to attend a particular Event, and is subject to any additional terms applicable to that Ticket that may be set by the venue or organization hosting the Event on the Ticket.
    </p>

    <ol>
      <li class="py-2">
        Ordering : You do not have (and should not assume that You have) a valid Ticket unless and until You receive a confirmation email, notification, or SMS from GoGoCinema.
      </li>

      <li class="py-2">
        Transaction Error: If Your credit card has been charged, GoGoCinema will refund You the amount that You paid.These remedies will apply regardless of whether the error is attributable to human error or a transactional malfunction of the Services.
      </li>

      <li class="py-2">
        Using Tickets: All Tickets and Concessions are non-refundable and not redeemable for cash, unless required by law.Tickets for admission to (and related Concessions for) a specific Event at a named venue have no value once the Event date and time has passed.
      </li>

      <li class="py-2">
        You may not transfer, reproduce, resell, modify, gift, or trade Tickets or Concessions.
      </li>

      <li class="py-2">
        Tickets are generally delivered through the App but may also be delivered via email or SMS.  Tickets may only be redeemed one time.  If You forward a Ticket and it is redeemed by another person, Your Ticket will no longer be valid.
      </li>

      <li class="py-2">
        If a venue does not honor the Ticket or Concessions, please contact Us promptly at <a href="">support@gogocinema.com</a>.
      </li>
      
      <li class="py-2">
        Cancelled Events. In the event an Event is canceled or postponed by the venue or organizer, We will provide You with a refund, credit, or exchange (in Our discretion). GoGoCinema will not be liable for any losses (monetary or otherwise) that You or anyone else incurs in connection with a canceled or postponed event.  Please contact Us at <a href="">support@gogocinema.com</a>
      </li>
    </ol>

    <p class="mb-0 py-3">
      Disclaimer: GoGoCinema sells Tickets and Concessions for Events, but is not responsible for the conditions at the venues where the Events take place, any aspect of the Concessions or for the actions of the Event promoters, the owners of the venue, or any participants or spectators at the Events.  The venue is solely responsible for (i) providing the Event or activity and all related goods and services; and (ii) any and all injuries, illnesses, damages, claims, liabilities, and costs You may suffer, directly or indirectly, as a result of You attending the Event.  If You are injured at an Event, immediately ask an usher for directions to a medical station.
    </p>

    <p class="mb-0 pt-3 pb-5">
      By purchasing a Ticket through GoGoCinema, You agree to these Terms on behalf of Yourself and any accompanying minor and You agree that You assume all risks incidental to the Event for which a Ticket is issued, whether before, during or after the Event.  To the fullest extent permissible under applicable law, GoGoCinema disclaims all liability for conditions at the venues where the Events take place, and for the actions of the Event promoters, the owners of the venue, or any participants or spectators at the Events, and You expressly waive any and all claims You might have against  GoGoCinema that arise from such conditions or actions.
    </p>
  </div>
</template>

<script>


  export default {
    name: 'terms-condition-ticket',
    directives: {
      // 'dragscroll': dragscroll
    },

    components: {
      
    },

    data() {
      return {
        
      }
    }
  }

</script>

<style>
.text-tc {
     font-size: 14px;
 }

 .title-tc {
     font-size: 30px;
 }
</style>



// WEBPACK FOOTER //
// src/components/pages/terms-condition-ticket.vue